'use strict';

var HttpRequestInterceptorFactory = function HttpRequestInterceptorFactory($q, $rootScope) {
  var loadingCount = 0;
  var userSessionCheckUrl = '/api/authenticateduser';
  function noSpinner(config) {
    return config.url && config.url.indexOf('noSpinner=true') !== -1 || config.params && config.params.noSpinner === true;
  }
  function counterUp() {
    if (++loadingCount === 1) {
      $rootScope.$broadcast('loading:progress');
    }
  }
  function counterDown() {
    if (--loadingCount === 0) {
      $rootScope.$broadcast('loading:finish');
    }
  }
  return {
    request: function request(config) {
      if (!noSpinner(config)) {
        counterUp();
      }
      return config || $q.when(config);
    },
    response: function response(_response) {
      if (!noSpinner(_response.config)) {
        counterDown();
      }
      return _response || $q.when(_response);
    },
    responseError: function responseError(response) {
      if (response.status === -1) {
        if (response.config.url === userSessionCheckUrl) {
          $rootScope.$broadcast('$userTimeout');
        } else {
          $rootScope.$broadcast('$userCheckTimeout');
        }
      }
      if (!noSpinner(response.config)) {
        counterDown();
      }
      return $q.reject(response);
    }
  };
};
HttpRequestInterceptorFactory.$inject = ['$q', '$rootScope'];
module.exports = HttpRequestInterceptorFactory;